import React from 'react';
import { IsotopeSchema } from './IsotopeSchema';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';

const IsotopeData = (props) => {
  const { block, data, onChangeBlock } = props;
  const schema = IsotopeSchema({ ...props });

  return (
    <BlockDataForm
      schema={ schema }
      title={ schema.title }
      onChangeField={(id, value) =>  {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={ data }
      block={ block } 
    />
  );
};
export default IsotopeData;